export default "__VITE_ASSET__Brlicg8f__"